export default "__VITE_ASSET__280d6bba__"